import { createSelector } from "@ngrx/store";
import { AuthSelector, Jurisdiction, JurisdictionSelector } from "@obg/ngx.core";

import { UserStates } from "../content/content.model";
import { CoreContentState } from "../state";

import { MenuItem, MenuItemGroup } from "./menu.model";
/**
 * @deprecated [fabric-deprecated] - Use fabric ContentService from svc-content instead
 */
export namespace MenuSelector {
	export const isBusy = (state: CoreContentState): boolean => state.menu.isBusy;

	export const getMenus = (state: CoreContentState): Record<string, MenuItemGroup> => state.menu.menus;

	export const getMenu =
		(key: string) =>
		(state: CoreContentState): MenuItemGroup | undefined =>
			state.menu.menus[key];

	export const getKeysLoaded = (state: CoreContentState): string[] => state.menu.keysLoaded;

	/**
	 * @deprecated [fabric-deprecated] - Use fabric ContentService.menu$ from svc-content instead
	 */
	export const get = (key: string) =>
		createSelector(
			getMenu(key),
			getNotificationsCount,
			JurisdictionSelector.get,
			AuthSelector.isAuthenticated,
			(group, notificationsCount, jurisdiction, isAuthenticated): MenuItemGroup | undefined => {
				if (!group) {
					return undefined;
				}

				const filteredItems = filterItemsByState(group.items, jurisdiction, isAuthenticated).map((item) => ({
					...item,
					children: item.children && filterItemsByState(item.children, jurisdiction, isAuthenticated),
				}));

				return {
					...group,
					items: includeNotificationsCount(filteredItems, notificationsCount),
				};
			}
		);

	const getNotificationsCount = (state: CoreContentState): Record<string, number> => state.menu.notificationsCount;

	const filterItemsByState = (
		items: MenuItem[],
		jurisdiction: Jurisdiction | undefined,
		isAuthenticated: boolean
	): MenuItem[] => {
		const userState = isAuthenticated ? UserStates.LoggedIn : UserStates.LoggedOut;

		return items
			.filter(
				(item) => !item.jurisdiction?.length || item.jurisdiction.some((x) => x === jurisdiction || x === "any")
			)
			.filter(
				(item) =>
					!item.userState?.length || item.userState.some((x) => x === userState || x === UserStates.Anyone)
			);
	};

	const includeNotificationsCount = (menuItems: MenuItem[], notificationsCount: Record<string, number>): MenuItem[] =>
		menuItems.map((item) => {
			if (item.children) {
				return {
					...item,
					notificationsCount:
						item.children.reduce((sum, child) => sum + (notificationsCount[child.key] ?? 0), 0) ||
						undefined,
				};
			}

			return { ...item, notificationsCount: notificationsCount[item.key] };
		});
}
